import React from 'react';
import './PendingMessage.scss';

export interface PendingMessageData {
  content: string;
  timestamp: Date;
}

interface PendingMessageProps {
  message: PendingMessageData;
}

/**
 * PendingMessage - Shows a message that is being sent with a loading indicator
 */
export const PendingMessage: React.FC<PendingMessageProps> = ({ message }) => {
  return (
    <div className="pending-message">
      <div className="pending-message__content">
        <div className="pending-message__text" dangerouslySetInnerHTML={{ __html: message.content }} />
        <div className="pending-message__status">
          <span className="pending-message__dots">
            <span className="pending-message__dot" />
            <span className="pending-message__dot" />
            <span className="pending-message__dot" />
          </span>
          <span className="pending-message__label">Sending...</span>
        </div>
      </div>
    </div>
  );
};

export default PendingMessage;
